import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { orderBy } from '@progress/kendo-data-query';
import { PDAuthService } from 'pdauth';
import { BooleanConverter } from '../../../inputConverter';
import { SystemMessagesService } from '../../../services/system-messages.service';
import { BaseComponent } from '../../base.component';
var dismissedCategoryName = 'Dismissed';
var SystemMessagesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SystemMessagesComponent, _super);
    function SystemMessagesComponent(_vcr, systemMessagesService, pdauth, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this._vcr = _vcr;
        _this.systemMessagesService = systemMessagesService;
        _this.pdauth = pdauth;
        _this.cdr = cdr;
        _this.unreadMessages = new EventEmitter();
        _this.adminMode = new EventEmitter();
        _this._active = false;
        _this.categories = [];
        _this._selectedCategory = 0;
        _this.dismissedCategoryId = -1;
        _this.userMessages = [];
        // Admin
        _this._isAdmin = false;
        _this._showAdmin = false;
        _this.addEdit = false;
        _this.defaultSort = {
            field: 'id',
            dir: 'desc'
        };
        _this.sort = [_this.defaultSort];
        _this.allSystemMessages = [];
        _this.currentMessage = {};
        _this.activate(true);
        return _this;
    }
    Object.defineProperty(SystemMessagesComponent.prototype, "active", {
        set: function (value) {
            this._active = BooleanConverter(value);
            this._active ? this.activate() : this.deactivate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemMessagesComponent.prototype, "selectedCategory", {
        get: function () {
            return this._selectedCategory;
        },
        set: function (val) {
            this._selectedCategory = val;
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemMessagesComponent.prototype, "filteredUserMessages", {
        get: function () {
            var _this = this;
            var retVal = [];
            switch (this.selectedCategory) {
                case 0:
                    retVal = this.userMessages.filter(function (message) { return !message.isDismissed; });
                    break;
                case this.dismissedCategoryId:
                    retVal = this.userMessages.filter(function (message) { return message.isDismissed; });
                    break;
                default:
                    retVal = this.userMessages.filter(function (message) { return !message.isDismissed && message.systemMessage.systemMessageCategoryId === _this.selectedCategory; });
                    break;
            }
            return retVal;
        },
        enumerable: true,
        configurable: true
    });
    SystemMessagesComponent.prototype.setUserSubscriptions = function (initial) {
        var _this = this;
        if (initial === void 0) { initial = false; }
        this.userSubscription = this.pdauth.getLoggedInUser().subscribe(function (user) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!user) return [3 /*break*/, 2];
                        this.userId = user.id;
                        return [4 /*yield*/, this.setCategories()];
                    case 1:
                        _a.sent();
                        this.getMessages(initial);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        this.permissionsSubsciption = this.pdauth.getLoggedInUserPermissions().subscribe(function (permissions) {
            if (permissions && permissions.includes('System Messages Admin')) {
                _this._isAdmin = true;
                _this.cdr.detectChanges();
            }
        });
    };
    SystemMessagesComponent.prototype.setCategories = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, _b, _c, _d, _e, _f, _g, category;
            return tslib_1.__generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        this.categories = [{ categoryName: 'All Active', id: 0 }];
                        _d = (_c = (_a = this.categories).push).apply;
                        _e = [_a];
                        return [4 /*yield*/, this.systemMessagesService.getSystemCategories()];
                    case 1:
                        _d.apply(_c, _e.concat([tslib_1.__spread.apply(void 0, [(_h.sent())])]));
                        this.dismissedCategoryId = Math.max.apply(Math, tslib_1.__spread(this.categories.map(function (category) { return category.id; }))) + 1;
                        this.categories.push({
                            categoryName: dismissedCategoryName,
                            id: this.dismissedCategoryId
                        });
                        try {
                            for (_f = tslib_1.__values(this.categories), _g = _f.next(); !_g.done; _g = _f.next()) {
                                category = _g.value;
                                if (category.categoryName.startsWith('System')) {
                                    category.categoryShortName = category.categoryName.replace('System ', '');
                                }
                                else {
                                    category.categoryShortName = category.categoryName;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    SystemMessagesComponent.prototype.getMessages = function (initial) {
        if (initial === void 0) { initial = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, _b, _loop_1, this_1, _c, _d, message;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.userId) return [3 /*break*/, 2];
                        _b = this;
                        return [4 /*yield*/, this.systemMessagesService.getUserMessageInbox(this.userId)];
                    case 1:
                        _b.userMessages = (_e.sent()).filter(function (um) {
                            var valid = !!um.systemMessage;
                            var now = new Date();
                            if (um.systemMessage.expirationDate && new Date(um.systemMessage.expirationDate) < now) {
                                valid = false;
                            }
                            if (um.systemMessage.startDate && new Date(um.systemMessage.startDate) > now) {
                                valid = false;
                            }
                            return valid;
                        });
                        _loop_1 = function (message) {
                            message.systemMessage.systemMessageCategory = this_1.categories.find(function (cat) { return cat.id === message.systemMessage.systemMessageCategoryId; });
                            if (message.systemMessage.systemMessageCategory.categoryName.toLowerCase().includes('outage')) {
                                message.isOutage = true;
                            }
                        };
                        this_1 = this;
                        try {
                            for (_c = tslib_1.__values(this.userMessages), _d = _c.next(); !_d.done; _d = _c.next()) {
                                message = _d.value;
                                _loop_1(message);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        this.getCount();
                        this.cdr.detectChanges();
                        if (initial) {
                            this.deactivate();
                        }
                        _e.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SystemMessagesComponent.prototype.getCount = function () {
        var unreadMessages = this.userMessages.filter(function (message) { return !message.isDismissed && !message.isRead; });
        this.unreadMessages.emit(unreadMessages.length);
    };
    SystemMessagesComponent.prototype.activate = function (initial) {
        if (initial === void 0) { initial = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setUserSubscriptions(initial);
                return [2 /*return*/];
            });
        });
    };
    SystemMessagesComponent.prototype.deactivate = function () {
        this.userSubscription.unsubscribe();
        this.permissionsSubsciption.unsubscribe();
        this.userId = null;
        this.showAdmin = false;
        this.cancel();
    };
    SystemMessagesComponent.prototype.dismissMessage = function (message) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.systemMessagesService.markUserMessageDismissed(this.userId, message.systemMessageId)];
                    case 1:
                        _a.sent();
                        message.isDismissed = true;
                        this.getCount();
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    SystemMessagesComponent.prototype.toggleOpen = function (message) {
        message.show = !message.show;
        this.markAsRead(message);
    };
    SystemMessagesComponent.prototype.markAsRead = function (message) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!message.isRead) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.systemMessagesService.markUserMessageRead(this.userId, message.systemMessageId)];
                    case 1:
                        _a.sent();
                        message.isRead = true;
                        this.getCount();
                        this.cdr.detectChanges();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SystemMessagesComponent.prototype.setSelectedCategory = function (systemMessageCategoryId) {
        this.selectedCategory = systemMessageCategoryId;
    };
    Object.defineProperty(SystemMessagesComponent.prototype, "isAdmin", {
        get: function () {
            return this._isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemMessagesComponent.prototype, "showAdmin", {
        get: function () {
            return this._showAdmin;
        },
        set: function (val) {
            if (this.isAdmin) {
                this._showAdmin = val;
                if (val) {
                    this.loadAllMessages();
                }
                else {
                    this.getMessages();
                    this.getCount();
                }
                this.adminMode.emit(this._showAdmin);
                this.cdr.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SystemMessagesComponent.prototype, "dataCategories", {
        get: function () {
            var _this = this;
            return this.categories.filter(function (c) { return c.id !== 0 && c.id !== _this.dismissedCategoryId; });
        },
        enumerable: true,
        configurable: true
    });
    SystemMessagesComponent.prototype.sortChange = function (sort) {
        this.sort = sort;
        if (!this.sort || !this.sort.length || !this.sort.filter(function (sd) { return sd.dir; }).length) {
            this.sort = [this.defaultSort];
        }
        this.sortMessages();
    };
    SystemMessagesComponent.prototype.sortMessages = function () {
        this.allSystemMessages = orderBy(this.allSystemMessages, this.sort);
    };
    SystemMessagesComponent.prototype.updateDateString = function (e) {
        return new Date(e);
    };
    SystemMessagesComponent.prototype.loadAllMessages = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, _b, _loop_2, this_2, _c, _d, message;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, this.systemMessagesService.getAllMessages()];
                    case 1:
                        _b.allSystemMessages = _e.sent();
                        _loop_2 = function (message) {
                            message.systemMessageCategory = this_2.categories.find(function (cat) { return cat.id === message.systemMessageCategoryId; });
                            if (message.systemMessageCategory.categoryName.startsWith('System')) {
                                message.systemMessageCategory.categoryShortName = message.systemMessageCategory.categoryShortName.replace('System ', '');
                            }
                        };
                        this_2 = this;
                        try {
                            for (_c = tslib_1.__values(this.allSystemMessages), _d = _c.next(); !_d.done; _d = _c.next()) {
                                message = _d.value;
                                _loop_2(message);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        this.sortMessages();
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    SystemMessagesComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.currentMessage.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.systemMessagesService.createSystemMessage(this.currentMessage, this.userId)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.systemMessagesService.saveSystemMessage(this.currentMessage, this.userId)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.addEdit = false;
                        this.currentMessage = null;
                        return [4 /*yield*/, this.loadAllMessages()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SystemMessagesComponent.prototype.cancel = function () {
        this.addEdit = false;
        this.currentMessage = null;
    };
    SystemMessagesComponent.prototype.editHandler = function (_a) {
        var dataItem = _a.dataItem;
        this.currentMessage = dataItem;
        this.addEdit = true;
    };
    SystemMessagesComponent.prototype.newMessage = function () {
        this.currentMessage = {
            message: '',
            startDate: new Date(),
            title: ''
        };
        this.addEdit = true;
    };
    SystemMessagesComponent.prototype.removeHandler = function (_a) {
        var dataItem = _a.dataItem;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.systemMessagesService.deleteSystemMessage(dataItem.id)];
                    case 1:
                        _b.sent();
                        this.allSystemMessages.splice(this.allSystemMessages.indexOf(dataItem), 1);
                        return [2 /*return*/];
                }
            });
        });
    };
    return SystemMessagesComponent;
}(BaseComponent));
export { SystemMessagesComponent };
